/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";
import config from "config"

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import routes, {authProps, state} from "routes.js";

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const classes = useStyles();
  
  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }
  const { color, logo, image, logoText, routes } = props;
  var links = (
    <List className={classes.list}>
      {routes.map((prop, key) => {
        var activePro = " ";
        var listItemClasses;
        var routeFullPath = "";
        if (prop.path === "/upgrade-to-pro") {
          activePro = classes.activePro + " ";
          listItemClasses = classNames({
            [" " + classes[color]]: true
          });
        } else if(prop.path === "/login") {
          return null;
        } 
        else if(prop.invisible) {
          return null;
        } 
        else if(prop.path === "/user" && props.rest.auth.isAuthenticated === false) {
          return null;
        }
        else if(prop.path === "/create" && props.rest.auth.isAuthenticated === false) {
          return null;
        } 
        else if(prop.path === "/read" && props.rest.auth.isAuthenticated === false) {
          return null;
        } 
        else if(prop.path === "/update" && props.rest.auth.isAuthenticated === false) {
          return null;
        } 
        else if(prop.path === "/delete" && props.rest.auth.isAuthenticated === false) {
          return null;
        }
        else if(prop.path === "/dashboard" && props.rest.auth.isAuthenticated === false) {
          return null;
        } else if(prop.path === "/servicios/" && props.rest.auth.productsAndServices === false) {
          return null;
        } else if(prop.path === "/tarjeta/"){
          if(prop.path === "/tarjeta/" && props.rest.auth.productsAndServices === false) {
            return null;
          } else if(prop.path === "/tarjeta/" && props.rest.auth.productsAndServices === true){
              if(props.rest.auth.currentUserTemplate.userURL === '/tarjeta/'){
                routeFullPath = prop.layout + props.rest.auth.currentUserTemplate.userURL
              } else{
                let route = props.rest.auth.currentUserTemplate.userURL;
                var pattern = "/admin/tarjeta/";
                var str2 = route.substr(route.indexOf(pattern), route.length);
                routeFullPath = str2;
                listItemClasses = classNames({
                  [" " + classes[color]]: activeRoute(routeFullPath)
                });
              }
          }
        } 
          
        else {
          routeFullPath = `${prop.layout}${prop.path}`;
          listItemClasses = classNames({
            [" " + classes[color]]: activeRoute(routeFullPath)
          });
        }
        const whiteFontClasses = classNames({
          [" " + classes.whiteFont]: activeRoute(routeFullPath)
        });
        return (
          <NavLink
            to={routeFullPath}
            className={activePro + classes.item}
            activeClassName="active"
            key={key}
            
          >
            <ListItem button className={classes.itemLink + listItemClasses}>
              {typeof prop.icon === "string" ? (
                <Icon
                  className={classNames(classes.itemIcon, whiteFontClasses, {
                    [classes.itemIconRTL]: props.rtlActive
                  })}
                >
                  {prop.icon}
                </Icon>
              ) : (
                <prop.icon
                  className={classNames(classes.itemIcon, whiteFontClasses, {
                    [classes.itemIconRTL]: props.rtlActive
                  })}
                />
              )}
              <ListItemText
                primary={props.rtlActive ? prop.rtlName : prop.name}
                className={classNames(classes.itemText, whiteFontClasses, {
                  [classes.itemTextRTL]: props.rtlActive
                })}
                disableTypography={true}
              />
            </ListItem>
          </NavLink>
        );
      })}
    </List>
  );
  var brand = (
    <div className={classes.logo}>
      <a
        href={`${config.app.url}/admin/dashboard`}
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive
        })}
        target="_blank"
        style={{fontSize: "16.4px"}}
      >
        <div className={classes.logoImage}>
          <img src={logo} alt="logo" className={classes.img} />
        </div>
        {logoText}
      </a>
    </div>
  );
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks props={props}/>}
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};
